// Gestao do mapa `tokens` (camada acima do `token` ativo) para o recurso de
// "Alternar Negocio" entre instalacoes. O `token` continua sendo a fonte da
// sessao ativa; o mapa `tokens` apenas guarda tokens previamente obtidos para
// que a troca de negocio nao exija novo login.

const TOKENS_KEY = "tokens";

function readMap() {
  try {
    const raw = localStorage.getItem(TOKENS_KEY);
    const parsed = raw ? JSON.parse(raw) : null;
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch (e) {
    return {};
  }
}

function writeMap(map) {
  try {
    localStorage.setItem(TOKENS_KEY, JSON.stringify(map));
  } catch (e) {
    // ignore
  }
}

export function getTokensMap() {
  return readMap();
}

export function getTokenForApi(apiUrl) {
  if (!apiUrl) return null;
  return readMap()[apiUrl] || null;
}

export function setTokenForApi(apiUrl, token) {
  if (!apiUrl || !token) return;
  const map = readMap();
  map[apiUrl] = token;
  writeMap(map);
}

export function removeTokenForApi(apiUrl) {
  if (!apiUrl) return;
  const map = readMap();
  if (apiUrl in map) {
    delete map[apiUrl];
    writeMap(map);
  }
}

export function clearAllTokens() {
  localStorage.removeItem(TOKENS_KEY);
}

export function hasTokenForApi(api) {
  return !!api && !!api.API_URL && !!getTokenForApi(api.API_URL);
}
